import React, { useContext, useEffect } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { routes } from '@vlabs/shared/navigation/routes';
import validate from '@vlabs/shared/validators';
import { Control, Modal } from '@vlabs/uikit';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useHistory, generatePath } from 'react-router-dom';
import { toast } from 'react-toastify';

import { QueueContext } from '../queue-context/QueueContext';
import st from './CreateQueueModal.module.sass';
import { defaultValuesQueue } from './defaultValuesForCreateQueue';

function createOptionsForInput(arrayOfStrings) {
  if (!arrayOfStrings) return null;
  return arrayOfStrings.filter((group) => group !== 'no_group').map((option) => ({ label: option, value: option }));
}

export function CreateQueueModal({ isOpen, onClose }) {
  const { t } = useTranslation();
  const { register, reset, handleSubmit, control, formState: { errors, isValid }, setValue } = useForm({ mode: 'onChange', defaultValues: defaultValuesQueue });
  const { groups, fetchStreams, editingGroupName } = useContext(QueueContext);
  const GROUP_OPTIONS = createOptionsForInput(groups);
  const history = useHistory();

  useEffect(() => {
    if (editingGroupName) {
      setValue('description.zone_group', { value: editingGroupName, label: editingGroupName });
    }
  }, [editingGroupName]);

  const onSubmit = async (data) => {
    // подменяем вручную прокси на значение из description.zone_group
    const stringDescription = JSON.stringify({
      ...data.description,
      zone_group: data.description.zone_group?.value || null,
    });

    // подменяем в форм дате
    const formDataWithStringDescription = {
      ...data,
      description: stringDescription,
    };

    const { stream_id: streamId } = await apiContainer.lunaClient.streams.create({
      payload: formDataWithStringDescription,
    });

    toast.success(t('videoAnalytics:create.success'));

    fetchStreams();

    const path = generatePath(routes.queue.edit, { streamId });
    history.push(path);
  };

  const handleModalClose = () => {
    reset(defaultValuesQueue);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleModalClose}
      size="small"
      data-testid="createQueueModal"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={st.Title}>{t('queue:queue page.create queue widget.modal content.title')}</div>
        <Control.Input
          {...register('name', {
            required: true,
            maxLength: validate.maxLength(128),
            validate: validate.regex(/^[\p{L}0-9_-]+$/u),
          })}
          className={st.Input}
          errors={errors}
          id="name"
          data-testid="queueNameInput"
          label={(
            <div>
              {t('queue:queue page.create queue widget.modal content.name input.label')}
              <span className={st.RedStar}> *</span>
            </div>
          )}
          name="name"
        />
        <Control.Input
          {...register('data.reference', {
            required: true,
          })}
          className={st.Input}
          errors={errors}
          id="data.reference"
          data-testid="queueSourcePathInput"
          label={(
            <div>
              {t('queue:queue page.create queue widget.modal content.reference input.label')}
              <span className={st.RedStar}> *</span>
            </div>
          )}
          name="data.reference"
        />
        <Control.Select
          className={st.Input}
          control={control}
          errors={errors}
          id="description.zone_group"
          data-testid="queueGroupSelectInput"
          isClearable
          isCreatable
          label={t('queue:queue page.create queue widget.modal content.group input.label')}
          name="description.zone_group"
          options={GROUP_OPTIONS}
        />
        <div className={st.ModalButtons}>
          <Control.Button
            data-testid="CreateQueueModal_submitButton"
            disabled={!isValid}
            type="submit"
          >
            {t('queue:queue page.create queue widget.modal content.submit button.label')}
          </Control.Button>
          <Control.Button
            data-testid="CreateQueueModal_cancelButton"
            onClick={handleModalClose}
          >
            {t('queue:queue page.create queue widget.modal content.cancel button.label')}
          </Control.Button>
        </div>
      </form>
    </Modal>
  );
}
